(() => {
  if (customElements.get("ingredients-slider")) return;

  class IngredientsSlider extends HTMLElement {
    constructor() {
      super();
      this.carousel = this.querySelector(".featured-ingredients__swiper");
      this.prevBtn = this.querySelector(".featured-ingredients__prev");
      this.nextBtn = this.querySelector(".featured-ingredients__next");
      this.progressFill = this.querySelector(".featured-ingredients__progress-fill");
      this.swiper = null;
    }

    connectedCallback() {
      this.initCarousel();
    }

    disconnectedCallback() {
      this.destroyCarousel();
    }

    updateProgress(swiper) {
      if (!this.progressFill || !swiper) return;
      const total = swiper.slides.length;
      let perView = swiper.params.slidesPerView;
      if (perView === 'auto') perView = swiper.slidesPerViewDynamic();
      if (!total || !perView) return;
      const fill = (swiper.progress * (total - perView) + perView) / total;
      this.progressFill.style.width = `${Math.min(fill, 1) * 100}%`;
    }

    initCarousel() {
      if (!this.carousel || this.swiper) return;

      // Optional: fixed-width slides (driven by CSS) instead of fractional
      // slidesPerView. Enabled per-instance via `data-auto-width="true"`.
      // Defaults keep the original behavior for existing templates.
      const autoWidth = this.dataset.autoWidth === 'true';

      const breakpoints = autoWidth
        ? {
            750: { slidesOffsetAfter: 0 },
            1300: { slidesOffsetAfter: 0 }
          }
        : {
            750: { slidesOffsetAfter: 0 },
            1024: { slidesPerView: 1.6, spaceBetween: 16, slidesOffsetAfter: 20 },
            1300: { slidesPerView: 2.22, spaceBetween: 16, slidesOffsetAfter: 0 }
          };

      const init = () => {
        this.swiper = new Swiper(this.carousel, {
          slidesPerView: autoWidth ? 'auto' : 1.46,
          spaceBetween: 16,
          slidesOffsetAfter: 20,
          draggable: true,
          grabCursor: true,
          navigation: {
            prevEl: this.prevBtn,
            nextEl: this.nextBtn,
          },
          on: {
            init: (swiper) => this.updateProgress(swiper),
            progress: (swiper) => this.updateProgress(swiper),
          },
          breakpoints: breakpoints
        });
      };

      if (typeof Swiper !== 'undefined') {
        init();
      } else {
        document.addEventListener('swiper:loaded', init, { once: true });
        
        const checkSwiper = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(checkSwiper);
            init();
          }
        }, 1000);

        this.swiperCheck = checkSwiper;
      }
    }

    destroyCarousel() {
      if (this.swiperCheck) clearInterval(this.swiperCheck);
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }
  }

  customElements.define("ingredients-slider", IngredientsSlider);
})();
